import { Controller } from "@hotwired/stimulus"
import Sortable from "sortablejs"

// Connects to data-controller="sortable"
export default class extends Controller {
  static values = { 
    recipeId: String,
    endpoint: String 
  }
  
  connect() {
    if (typeof Sortable === 'undefined') {
      console.error("SortableJS not loaded!")
      return
    }
    
    // Track whether items have been reordered
    this.hasBeenReordered = false
    
    this.sortable = Sortable.create(this.element, {
      handle: '.drag-handle',
      animation: 150,
      ghostClass: 'sortable-ghost',
      chosenClass: 'sortable-chosen',
      dragClass: 'sortable-drag',
      onEnd: (event) => {
        // Only update if the item actually moved to a different position
        if (event.oldIndex !== event.newIndex) {
          this.hasBeenReordered = true
          this.updateOrder(event)
        }
      }
    })
  }

  disconnect() {
    if (this.sortable) {
      this.sortable.destroy()
      this.sortable = null
    }
  }

  updateOrder(event) {
    // Only update hidden form field if items have actually been reordered
    if (this.hasBeenReordered) {
      this.updateHiddenFormField()
    }
    
    // Dispatch event for any other controllers that might need to know about reordering
    this.dispatch('reorder', { 
      detail: { 
        oldIndex: event.oldIndex, 
        newIndex: event.newIndex,
        type: this.endpointValue.includes('ingredients') ? 'ingredients' : 'instructions'
      } 
    })
  }

  updateHiddenFormField() {
    // Get the current order of items and extract their data to build the reordered JSON
    const items = Array.from(this.element.children)
    const reorderedData = []
    
    items.forEach((item, index) => {
      if (this.endpointValue.includes('ingredients')) {
        // For ingredients, the data-ingredient-index is on the item itself
        if (item.hasAttribute('data-ingredient-index')) {
          const originalIndex = parseInt(item.dataset.ingredientIndex)
          const originalData = this.getOriginalIngredientData(originalIndex)
          if (originalData) {
            reorderedData.push(originalData)
          }
        }
      } else {
        // For instructions, the data-instruction-index is on the item itself
        if (item.hasAttribute('data-instruction-index')) {
          const originalIndex = parseInt(item.dataset.instructionIndex)
          const originalData = this.getOriginalInstructionData(originalIndex)
          if (originalData) {
            reorderedData.push(originalData)
          }
        }
      }
    })
    
    // Find the form and update the appropriate hidden field with complete JSON data
    const form = this.element.closest('form')
    if (form) {
      const fieldName = this.endpointValue.includes('ingredients') ? 'ingredients' : 'instructions'
      let hiddenField = form.querySelector(`input[name="recipe[${fieldName}]"]`)
      
      // Create the hidden field if it doesn't exist
      if (!hiddenField) {
        hiddenField = document.createElement('input')
        hiddenField.type = 'hidden'
        hiddenField.name = `recipe[${fieldName}]`
        form.appendChild(hiddenField)
      }
      
      // Update the value with the complete reordered JSON data
      hiddenField.value = JSON.stringify(reorderedData)
    }
  }

  getOriginalIngredientData(index) {
    if (window.recipeData && window.recipeData.ingredients && window.recipeData.ingredients[index]) {
      return window.recipeData.ingredients[index]
    }
    return null
  }

  getOriginalInstructionData(index) {
    if (window.recipeData && window.recipeData.instructions && window.recipeData.instructions[index]) {
      return window.recipeData.instructions[index]
    }
    return null
  }
}